export const findClosestIndexByStart = (
	items: { start: number }[],
	targetStart: number
) => {
	if (!items.length) return -1

	let closestIndex = 0
	let minDistance = Infinity

	items.forEach((item, index) => {
		const distance = Math.abs(item.start - targetStart)

		if (distance < minDistance) {
			minDistance = distance
			closestIndex = index
		}
	})

	return closestIndex
}
